import moment from 'moment';

import FLAG from 'config/flag.singleton';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import { formatYearToDayStandard } from 'utils/date/format.util';
import zonedMoment from 'utils/date/zonedMoment.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const L = logger('determineHiddenStylistIds');

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const determineHiddenStylistIds = withOptions((options) => {
  const { currentDay, events, tz, tag } = options;

  if (!isFullArray(events)) return [];

  const current = tz ? zonedMoment(tz, currentDay) : moment(currentDay);
  const ids = [];

  for (const event of events) {
    const { stylist_id: id, end_time: endTime, show_stylist: showStylist } = asObject(event);

    if (showStylist !== false) {
      if (USE_SPAM_LOG) L.debug('()', tag, 'Skipping id:', id, 'because of showStylist:', showStylist);
      continue;
    }

    // Every time we fetch events for a date, we push them into an array and we persist all events while navigating.
    // This is filtering out events that are not for the current selected date from our calendar.
    // Potential fix is to show all events for the current date and not persist previous ones.
    if (formatYearToDayStandard(endTime) !== formatYearToDayStandard(current)) {
      if (USE_SPAM_LOG) {
        const iso = fromAnyDateToIso(current);
        L.debug('()', tag, 'Skipping id:', id, 'endTime:', endTime, 'is same day as the current:', iso);
      }
      continue;
    }

    if (ids.includes(id)) {
      if (USE_SPAM_LOG) L.debug('()', tag, 'Skipping id:', id, 'It is already in ids:', ids);
      continue;
    }

    ids.push(id);
  }

  if (USE_SPAM_LOG) L.debug('()', tag, 'Should hide stylists with ids:', ids);

  return ids;
});

export default determineHiddenStylistIds;
